import * as React from "react";

import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useTheme } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  Tab,
  Tabs,
  useMediaQuery,
  makeStyles,
} from "@material-ui/core";
import { useRouter } from "next/router";

import AgapeLoading from "../../components/common/loading/Loading";
import {
  error,
  fetchGiftCategories,
  loadings,
  selectField,
  selectImage,
  setField,
} from "../../redux/slices/giftCardSlice";
import Public from "../../layouts/public/Public";
import { getApiService, getOrganizationPublic } from "../../services/AgapeAPI";
import { toast } from "react-toastify";
import { setLogin } from "../../redux/slices/publicSlice";
// import StaticsGiftCard from '../../components/other/giftCard/StaticsGiftCard';

const tabData = [
  { text: "خرید کارت نیکوکاری" },
  { text: "کارت نیکوکاری چیست" },
];

const useStyles = makeStyles((theme) => ({
  specialNotice: {
    width: "fit-content",
    marginTop: "100px",
    padding: "14px 10px",
    backgroundColor: "#c4c4c420",
    borderLeft: "6px solid orange",
    [theme.breakpoints.down("md")]: {
      marginTop: "50px",
    },
  },
  /// tab =>
  tabSelector: {
    position: "relative",
    // maxWidth: '75.65%',
    [theme.breakpoints.only("md")]: {
      maxWidth: "100%",
    },
    marginTop: "40px",

    marginBottom: "10px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  tabContainer: (props) => ({
    border: `2px solid ${theme.palette.grey.main}`,
    borderRadius: "10px",
    padding: "10px",
    overflow: "visible !important",
    "&::-webkit-scrollbar": {
      width: "10px",
      height: "13px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ededed",
      borderRadius: "50px",
    },
    "&::-webkit-scrollbar-thumb": {
      height: "6px",
      border: "4px solid rgba(0, 0, 0, 0)",
      backgroundClip: "padding-box",
      backgroundColor: "#8898aa",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#525b67",
    },
    "& .MuiTab-wrapper": {
      padding: "5px",
      borderRadius: "10px",
      fontSize: "1.418rem !important",
      fontWeight: "bold",
      fontFamily: "Vazir-Bold",
    },

    "& .MuiTabs-scroller": {
      overflow: "visible !important",
    },
    "& .MuiTab-root": {
      minWidth: "0 !important",
      width: "100%",
      [theme.breakpoints.down("sm")]: {
        width: "50%",
      },
    },
    "& .MuiTabs-flexContainer": {
      // justifyContent: 'space-between',
    },
    "& .Mui-selected": {
      "& .MuiTab-wrapper": {
        borderRadius: "10px",
        boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
        backgroundColor: "white",
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#18c5bf",
      height: "5px",
      marginBottom: "-12.5px",
      borderRadius: "50px",
    },
  }),
  // tab end
}));

const StaticsGiftCard = dynamic(
  () => import("../../components/other/giftCard/StaticsGiftCard"),
  { loading: () => <AgapeLoading internal={false} /> }
);

const GiftCardMobile = dynamic(
  () => import("../../components/other/giftCard/GiftCardMobile"),
  { loading: () => <AgapeLoading internal={false} /> }
);

const GiftCardDesktop = dynamic(
  () => import("../../components/other/giftCard/GiftCardDesktop"),
  { loading: () => <AgapeLoading internal={false} /> }
);

const GiftCard = ({ seo, ...props }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const image = useSelector(selectImage);
  const router = useRouter();
  const { orgId } = router.query;
  const errors = useSelector(error);
  // const loading = useSelector(loadings);
  const classes = useStyles();
  const [hasOrg, setHasOrg] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  // const {routeFromOrganizationPage} = router.query;
  const setTab = (value) => dispatch(setField({ field: "tab", value }));

  const tab = useSelector((state) => selectField(state, "tab"));

  const handleTabChange = (event, newTab) => {
    setTab(newTab);
    // change active card to first item of the tab
  };

  React.useEffect(() => {
    if (errors === "403") {
      toast.error("لطفا ابتدا لاگین کنید.");
      dispatch(setLogin(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);
  React.useEffect(() => {
    dispatch(fetchGiftCategories());
    dispatch(setField({ field: "step", value: 0 }));

    // if (location.state?.routeFromOrganizationPage) {
    //   alert('from onepage');
    // } else {
    //   dispatch(fetchGiftOrganizations());
    // }

    if (orgId) {
      setLoading(true);
      setHasOrg(true);
      dispatch(setField({ field: "type", value: "organization" }));

      getOrganizationPublic(orgId)
        .then((response) => {
          setLoading(false);
          dispatch(setField({ field: "org", value: response.data }));
          dispatch(setField({ field: "type", value: "organization" }));
          setHasOrg(true);
        })
        .catch(() => {
          setLoading(false);
          setHasOrg(false);
          dispatch(setField({ field: "type", value: "" }));
        });
      // dispatch(setField({ field: 'org', value: orgId }));
    }
  }, [dispatch, orgId]);

  const giftMaker = () => {
    return (
      <>
        {loading ? (
          <AgapeLoading internal={false} />
        ) : (
          <>
            {isMobile && (
              <GiftCardMobile {...props} routeFromOP={orgId} hasOrg={hasOrg} />
            )}
            {!isMobile && image ? (
              <GiftCardDesktop {...props} routeFromOP={orgId} hasOrg={hasOrg} />
            ) : null}
          </>
        )}
      </>
    );
  };

  const renderedComponent = [giftMaker(), <StaticsGiftCard key={2} />];

  return (
    <>
      {seo && (
        <Head>
          <title>{seo.title}</title>
          <meta property="og:image" content={seo["og:image"]} />
          <meta property="og:site_name" content={seo["og:site_name"]} />
          <meta property="og:title" content={seo["og:title"]} />
          <meta property="og:type" content={seo["og:type"]} />
          <meta property="og:url" content={seo["og:url"]} />
          <meta property="twitter:creator" content={seo["twitter:creator"]} />
          <meta
            property="twitter:description"
            content={seo["twitter:description"]}
          />
          <meta property="twitter:image" content={seo["twitter:image"]} />
          <meta property="twitter:site" content={seo["twitter:site"]} />
          <meta property="twitter:title" content={seo["twitter:title"]} />
          <meta name="description" content={seo.description} />
        </Head>
      )}

      {/* {isMobile && (
        <GiftCardMobile
          {...props}
          routeFromOP={location?.state?.routeFromOrganizationPage}
        />
      )}
      {!isMobile && image ? (
        <GiftCardDesktop
          {...props}
          routeFromOP={location?.state?.routeFromOrganizationPage}
        />
      ) : null} */}
      <Container>
        <Grid item container md={12}>
          <Grid item md className={classes.tabSelector}>
            <Tabs
              value={tab}
              onChange={handleTabChange}
              className={classes.tabContainer}
            >
              {tabData &&
                tabData.map((gTab, index) => (
                  <Tab
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    label={gTab.text}
                    key={gTab.text}
                  />
                ))}
            </Tabs>
          </Grid>
        </Grid>
        {renderedComponent[tab]}
      </Container>
    </>
  );
};

// export async function getStaticProps() {
//   const res = await getApiService('seo/pages/gift-cards');
//   const seo = await res.data;

//   return {
//     props: {
//       seo,
//     },
//   };
// }

GiftCard.getLayout = function getLayout(page) {
  return <Public>{page}</Public>;
};

export default GiftCard;
